<template>
  <div class="main">
    <ul id="leaveTypeNav" class="nav nav-tabs" role="tablist" style="width:100%;">
      <li class="text-center" data-leaveType="BELONG" role="presentation">
        <a data-toggle="tab" @click="selectionLeaveItemType('BELONG')">退宿財產清單</a>
      </li>
      <li class="text-center" data-leaveType="MILIEU" role="presentation">
        <a data-toggle="tab" @click="selectionLeaveItemType('MILIEU')">環境清潔</a>
      </li>
      <li class="text-center" data-leaveType="KEY" role="presentation">
        <a data-toggle="tab" @click="selectionLeaveItemType('KEY')">Key</a>
      </li>
    </ul>
    <section class="panel panel-default" style="margin-bottom: 0px;">
    </section>
    <div id="leaveTypeContent" class="tab-content">
      <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
        <div class="row form-group">
          <div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <button class="btn btn-danger hidden-xs" @click="openEditPopup(null)">新增項目</button>
              <button class="btn btn-danger btn-block visible-xs" @click="openEditPopup(null)">新增項目</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
              <tr>
                <th class="text-center" width="15%">識別碼</th>
                <th class="text-center" width="65%">名稱</th>
                <th class="text-center" width="8%"></th>
                <th class="text-center" width="8%"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td class="text-center" data-title="">{{item.commCode}}</td>
                <td class="text-center" data-title="">{{item.commValue}}</td>
                <td class="text-center" data-title="">
                  <button type="button"  @click="openEditPopup(item)" class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" >編輯</button>
                </td>
                <td class="text-center" data-title="">
                  <button type="button"  @click="deleteLeaveItem(item.commCode)" class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" >刪除</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <editPopup v-if="isOpenEditPopup" :data="selected" :is-edit="isEdit" :type="type"/><div class="col-md-12">
    <div class="s_tenc">
      <a @click="$router.go(-1);" class="btn-upload btn s_btn_g">返回</a>
    </div>
  </div>
  </div>
</template>

<script>
import editPopup from './editPopup';
export default {
  components:{
    editPopup
  },
  data() {
    return {
      type: "BELONG",
      data: [],
      selected: null,
      isOpenEditPopup: false,
      isEdit: false
    }
  },
  mounted() {
    this.navInitEvent();
    this.updateGrid();
  },
  methods: {
    selectionLeaveItemType(type) {
      this.type = type;
      this.updateGrid();
    },
    updateGrid(page = 1) {
      this.page = page;
      const api = `/api/room/leaveItem/${this.type}`;
      this.$axios.get(api).then(resp =>{
        this.data = resp.data.data;
      });
    },
    deleteLeaveItem(code) {
      if (!confirm("請問是否確認要刪除勾選的資料？")) return false;
      this.$http.delete(`/api/room/deleteLeaveItem/${this.type}/${code}`)
        .then(a => {
          if (a.body.status) {
            this.updateGrid();
          }
          alert(a.body.msg);
      });
    },
    navInitEvent(){
      if(this.type == "" || this.type == "BELONG") {
        document.querySelector("[id='leaveTypeNav']").children[0].classList.add("active");
      }
      else if(this.type == "MILIEU") {
        document.querySelector("[id='leaveTypeNav']").children[1].classList.add("active");
      }
      else if(this.type == "KEY") {
        document.querySelector("[id='leaveTypeNav']").children[2].classList.add("active");
      }
    },
    openEditPopup(item) {
      this.selected = item;
      this.isEdit = !!item
      this.isOpenEditPopup = true;
    }
  }
}
</script>
